module.exports = __webpack_public_path__ + "img/image5.3a67167e.png";